import { HtmlControlType } from 'src/app/enums/htmlControlType';
import { QueryFilterParameter } from '../widgets/filters/models/query-filter-parameter.model';

/*

Create By: Amit Gupta
-----------------------filter funcation common classes------------------
FiltersOutput:
FilterOutput:
FilterInput: 

details to be added here. still pending for implementation

*/
export class FiltersOutput {
  settingGroupId?: number;
  filters: FilterOutput[] = [];
  action: string; 
}

export class FiltersOutputNew {
  SettingGroupId?: number;
  filtersOptions: FilterOutput[] = [];
  Action: string;
}


export class FilterOutput {
  settingId: number;
  fieldValue: string;
}
export class FilterValue{
  columnName:string
  value:string
}

export class FilterInput {
  displayName: string;
  fieldId: number;
  fieldName: string;
  orderNumber: string;
  htmlControlType: HtmlControlType;
  selectionId: number;
  values: any;
  defaultFilterValue: string;
  selectedValue: string;
  selectedValues: string[];
  isVisible: boolean;
  selectionName: string;
	selectionMode: string;
}

export class ExportData {
  fromPeriod: string;
  toPeriod: string;
  isAgg: number;
  type: string;
  title: string;
  filename: string;
  filters: ExportFilter[] = [];
  fileType: string;
}

export class ExportFilter {
  columnName: string
  value: string
}

export class ExportPeriod {
  period: string;
}

export class FilterMappingService {
  // Method to map an array of FilterOutput to an array of FilterValue
  mapFilterOutputToFilterValue(filterOutputs: FilterOutput[]): ExportFilter[] {
    return filterOutputs.map(output => ({
      columnName: output.settingId.toString(), // Convert number to string
      value: output.fieldValue
    }));
  }

  mapFilterOutputMultiToFilterValue(filterOutputs: FilterOutput[]): ExportFilter[] {
    // Use flatMap to transform each JSON string value into separate objects
    let transformedOutputs = filterOutputs.flatMap(output => {
      // Parse the JSON string to get an actual array of strings
      let valuesArray: string[] = JSON.parse(output.fieldValue);
      
      // Map over the array of strings to create an array of objects for each value
      return valuesArray.map(value => ({
        columnName: output.settingId.toString(), // Keep the columnName as is
        value: value // Assign each string in the array to the value property
      }));
    });

    return transformedOutputs;
  }

  mapQueryFilterOutputToFilterValue(filterOutputs: QueryFilterParameter[]): ExportFilter[] {
    return filterOutputs.map(output => ({
      columnName: output.fieldName.toString(), // Convert number to string
      value: output.value
    }));
  }

}